import { RoleMappings } from "src/app/_enums/RoleMappings";
import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [
  {
    path: "/portal/dashboard/main",
    title: "Acasa",
    moduleName: "dashboard",
    iconType: "material-icons-two-tone",
    icon: "home",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [],
    submenu: [],
  },
  {
    path: "",
    title: "Administrare",
    moduleName: "admin",
    iconType: "material-icons-two-tone",
    icon: "settings",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [RoleMappings.Admin],
    submenu: [
      {
        path: "/portal/admin/accounts",
        title: "Utilizatori",
        moduleName: "admin",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/admin/organizations",
        title: "Spitale",
        moduleName: "admin",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/admin/doctor-nomenclature",
        title: "Nomenclator medici",
        moduleName: "admin",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/admin/configurations",
        title: "Configurari",
        moduleName: "admin",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      }
    ],
  },
  {
    path: "/portal/contributor/news",
    title: "Administrare stiri",
    moduleName: "contributor",
    iconType: "material-icons-two-tone",
    icon: "article",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [RoleMappings.Admin, RoleMappings.Contributor],
    submenu: [],
  },
  {
    path: "",
    title: "Rapoarte",
    moduleName: "reports",
    iconType: "material-icons-two-tone",
    icon: "insert_chart",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [RoleMappings.Admin],
    submenu: [
      {
        path: "/portal/reports/authentications",
        title: "Autentificari",
        moduleName: "reports",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/reports/signups",
        title: "Conturi create",
        moduleName: "reports",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/reports/signupsbyaccount",
        title: "Conturi create de medic",
        moduleName: "reports",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/reports/appointments",
        title: "Programari",
        moduleName: "reports",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/reports/failed-signups",
        title: "Erori creare cont",
        moduleName: "reports",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Dosar medical",
    moduleName: "medical-record",
    iconType: "material-icons-two-tone",
    icon: "folder_shared",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [RoleMappings.Patient],
    submenu: [
      {
        path: "/portal/medical-record/historic",
        title: "Istoric medical",
        moduleName: "medical-record",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/medical-record/historic-ca",
        title: "Cereri de analize",
        moduleName: "medical-record",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/medical-record/medical-informations",
        title: "Informatii medicale",
        moduleName: "medical-record",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/medical-record/access-rights",
        title: "Drepturi de acces",
        moduleName: "medical-record",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      }
    ],
  },
  {
    path: "/portal/patient-medical-record",
    title: "Dosare medicale pacienti",
    moduleName: "patient-medical-record",
    iconType: "material-icons-two-tone",
    icon: "folder_shared",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [RoleMappings.Doctor],
    submenu: [],
  },
  {
    path: "",
    title: "Programari",
    moduleName: "appointments",
    iconType: "material-icons-two-tone",
    icon: "event_note",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [RoleMappings.Patient, RoleMappings.Doctor],
    submenu: [
      {
        path: "/portal/appointments/add-appointment",
        title: "Adaugare programare",
        moduleName: "appointments",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [],
        submenu: [],
      },
      {
        path: "/portal/appointments/view",
        title: "Registru programari",
        moduleName: "appointments",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [RoleMappings.Patient],
        submenu: [],
      },
      {
        path: "/portal/appointments/view-by-doctor",
        title: "Registru programari medici",
        moduleName: "appointments",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: [RoleMappings.Doctor],
        submenu: [],
      }
    ],
  },
  {
    path: "/portal/profile/{accountID}",
    title: "Contul meu",
    moduleName: "account",
    iconType: "material-icons-two-tone",
    icon: "person",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: [],
    submenu: [],
  },
];
